import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getDocs, query, where, collection, orderBy } from "firebase/firestore";
import { db } from "../firebase.js";
import { Helmet } from "react-helmet";
import Loadingimg from "../components_root/loadingimg.jsx";
import { IoIosGitCompare } from "react-icons/io";
import { CiRead } from "react-icons/ci";
import Rating from "../view_root/rating.js";
import { MdShoppingCart, MdKeyboardArrowRight, MdOutlineVerifiedUser, MdStarOutline, MdMergeType, MdInfoOutline, MdArrowRight } from "react-icons/md";
import "./compare.css";
import UpdateView from "../view_root/updateview.js";
import UpdateCompare from "../view_root/updatecompare.js";
import Saved from "../view_root/saved.js";
import CompareTechnicalDetails from "./compare_technicaldetails.jsx";
import Add_cart from "../cart_root/add_cart.js";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description:
        "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords:
        "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png",
};

export default function Compare() {
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [productsData, setProductsData] = useState([]);
    const [compareData, setCompareData] = useState([]);
    const [metaTitle, setMetaTitle] = useState(seo.title);
    const [metaKeywords, setMetaKeywords] = useState(seo.keywords);
    useEffect(() => {
        const fetchProducts = async () => {
            const params = new URLSearchParams(location.search);
            const uid = params.get("uid");

            if (!uid) {
                setIsLoading(false);
                return;
            }

            try {
                UpdateCompare(uid);

                setIsLoading(true);
                const Query = query(
                    collection(db, "products"),
                    where("uid", "==", uid),
                    where("status", "==", true)
                );

                const snapshot = await getDocs(Query);
                const products = await Promise.all(
                    snapshot.docs.map(async (docSnap) => {
                        const docData = docSnap.data();
                        const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
                        let child = [];
                        fieldsSnap.forEach((fieldDoc) => {
                            const { fieldName, fieldValue, category } = fieldDoc.data();
                            child.push({ fieldName, fieldValue, category });
                        });
                        return { uid: docSnap.id, ...docData, child };
                    })
                );

                setProductsData(products);

                if (products.length > 0) {
                    const titles = products.map((c) => c.title).join(" | ");
                    const keywords = products.map((c) => c.keywords).join(", ");
                    setMetaTitle(`${titles} | Compare on aooz`);
                    setMetaKeywords(keywords);
                }
            } catch (err) {
                console.error("Error fetching products:", err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchProducts();
    }, [location]);

    //CompareData
    useEffect(() => {
        const fetchProducts = async () => {
            const params = new URLSearchParams(location.search);
            const cat = params.get("cat");
            const scat = params.get("scat");

            if (!cat || !scat) {
                setIsLoading(false);
                return;
            }

            try {
                setIsLoading(true);

                // Firestore query without "!="
                const Query = query(
                    collection(db, "products"),
                    where("category", "==", cat),
                    where("subcategory", "==", scat),

                    where("status", "==", true)
                );

                const snapshot = await getDocs(Query);
                const products = await Promise.all(
                    snapshot.docs.map(async (docSnap) => {
                        const docData = docSnap.data();
                        const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
                        const child = fieldsSnap.docs.map((fieldDoc) => fieldDoc.data());

                        return { uid: docSnap.id, ...docData, child };

                        // let child = [];
                        // fieldsSnap.forEach((fieldDoc) => {
                        //     const { fieldName, fieldValue, category } = fieldDoc.data();


                        //     child.push({ fieldName, fieldValue, category });
                        // });
                        // return { uid: docSnap.id, ...docData, child };
                    })
                );
                // Filter out the first product manually
                const filteredProducts = products.filter(p => p.uid !== productsData[0]?.uid);

                setCompareData(filteredProducts);
            } catch (err) {
                console.error("Error fetching products:", err);
            } finally {
                setIsLoading(false);
            }
        };

        if (productsData.length > 0) fetchProducts();
    }, [location, productsData]);


    return (
        <div className="container_roots">
            <Helmet>
                <title>{metaTitle}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={metaKeywords} />
                <meta property="og:title" content={metaTitle} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_size p-3">
                <div className="post-container">
                    <div className="post_div">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="items-center">
                                            {productsData[0]?.category && (
                                                <a className="text-off text-h3 cursor fcap hover-under">
                                                    {productsData[0]?.category}
                                                </a>
                                            )}
                                            {productsData[0]?.subcategory && (
                                                <>
                                                    <MdKeyboardArrowRight className="icon-0 center text-off m-0" />
                                                    <a className="text-off text-h3 cursor fcap hover-under">
                                                        {productsData[0]?.subcategory}
                                                    </a>
                                                </>
                                            )}
                                            {productsData[0]?.item && (
                                                <>
                                                    <MdKeyboardArrowRight className="icon-0 center text-off m-0" />
                                                    <a className="text-off text-h3 cursor fcap hover-under">
                                                        {productsData[0]?.item}
                                                    </a>
                                                </>
                                            )}
                                            {productsData[0]?.usecase && (
                                                <>
                                                    <MdKeyboardArrowRight className="icon-0 center text-off m-0" />
                                                    <a className="text-off text-h3 cursor fcap hover-under">
                                                        {productsData[0]?.usecase}
                                                    </a>
                                                </>
                                            )}
                                        </div>
                                    </td>


                                </tr>
                            </tbody>
                        </table>

                    </div>
                    <div className="post_updates">
                        {/* Performance, Value & Trust Tips */}
                        <div className="text-h2">
                            aooz Knowledge-Based Ads & Smart Product Comparison
                        </div>

                    </div>

                </div>
                <div className="button-ui1 bold"><IoIosGitCompare className="icon" /> Compare
                    {compareData.length} Items</div>



                <div className="post-container">
                    <div className="post_updates ">

                        {/* Compare Technical Details */}
                        <div className="ui-grid-fill">
                            {isLoading ? (
                                <Loadingimg />
                            ) : productsData.length === 0 ? (
                                <div>No categories found or Checking the connection</div>
                            ) : (
                                productsData.map((row, index) => (
                                    <div className="ui-items items-back  rounded" key={index}>

                                        <div
                                            className="w-back-30"
                                            style={{
                                                zIndex: "2",
                                                position: "absolute",
                                                left: "0px",
                                                right: "0px",
                                                top: "0px",
                                            }}
                                        >
                                            <table>
                                                <tr>
                                                  
   <td><div className="button-ui2 text-h2 bold fcap">{row.brandname}</div></td>
     <td width={100}><div className="button-ui2 bold">You Compare</div></td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div style={{ position: "relative" }}>
                                            <div className="w-back-30" style={{ zIndex: "2", position: "absolute", left: "0px", right: "0px", bottom: "0px" }}>
                                                <table>
                                                    <tr>
                                                        <td><div className="text-shadow-w text-h2 fcap bold">{row?.modelname}</div></td>
                                                        <td width={90} > <Rating productId={row.uid} /></td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <img src={row.thumbnail} onClick={() => navigate("/" + row.slug)} className="ads-items-default" />
                                        </div>

                                        <div className="p-1"  >
                                            <div className="text-h3 fcap m-b">{row.title.substring(0, 215)}</div>

                                            {row.child?.dealname != null && (
                                                <div>
                                                    <a className="red text-h3 items-back   rounded-sm">Deal: {row.child?.dealname}</a>
                                                </div>
                                            )}
                                            {Array.isArray(row.child) &&
                                                row.child.some(field => (field.category || "").toLowerCase() === "price") ? (
                                                row.child
                                                    .filter(
                                                        field =>
                                                            (field.category || "").toLowerCase() === "price" &&
                                                            field.fieldName !== "dealname"
                                                    )
                                                    .map((field, fIndex) => (
                                                        <div className="b-top" key={fIndex}>
                                                            <table>
                                                                <tbody>
                                                                    <tr>
                                                                        <td >
                                                                            <div className="text-h3 fcap p-11">
                                                                                {field.fieldName?.replaceAll("_", " ")}
                                                                            </div>
                                                                        </td>
                                                                        <td width={100}>
                                                                            <div className="flex">
                                                                                {field.fieldName === "discount" ? (
                                                                                    <>

                                                                                        <div className="text-h1 bold red">{field.fieldValue || ""}</div>
                                                                                        <span className="text-off text-h2">%</span>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span className="text-off text-h2">₹ </span>
                                                                                        <div className="text-h1 bold">{field.fieldValue || ""}</div>
                                                                                        <span className="text-off text-h2">.00</span>
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ))
                                            ) : (
                                                <div className="p-2 text-h3 text-off">No price available</div>
                                            )}
  <div className="m-top-5 ">
                                                  <table className="table-fixed">
                                                                  <tr>
                                                          <td width={22}>{<Saved product={row.uid} />}</td>
                                                                  
                                                                    <td width={40} >
                                                                      <div title="Compare" className="button-ui3 cursor "
                                                                        onClick={() => navigate("/compare/?slug=" + row.slug + "&uid=" + row.uid + "&cat=" + row.category + "&scat=" + row.subcategory)}
                                                                      ><IoIosGitCompare className="icon" /> {row.compare} </div>
                                                                    </td>
                                                        
                                                                      <td width={30}  >
                                                                      <Add_cart product={row.uid} />
                                                                    </td>
                                                                  </tr>
                                                                </table>
                                            </div>
                                            <table className="table-fixed ">

                                                <tr>
                                                    <td><div onClick={() => navigate("/" + row.slug)} className="button-ui p-2 fill cursor"><MdShoppingCart className="icon" /> Buy Now</div></td>
                                                </tr>
                                            </table>



                                        </div>
                                        <CompareTechnicalDetails isLoading3={isLoading} technicaldata={productsData} />
                                    </div>
                                ))
                            )}


                        </div>
                        <br /><br />
                    </div>
                    <div className="post_div">
                        <div className="ui-grid-mobile-1item m-top ">


                            {isLoading ? (
                                <Loadingimg />
                            ) : compareData.length === 0 ? (
                                <div>No categories found or Checking the connection</div>
                            ) : (
                                compareData.map((row, index) => (
                                    <div className="ui-items items-back b-1 rounded" key={index}>
                                        <div
                                            className="w-back-30"
                                            style={{
                                                zIndex: "2",
                                                position: "absolute",
                                                left: "0px",
                                                right: "0px",
                                                top: "0px",
                                            }}
                                        >
                                            <table>
                                                <tr>
                                                       <td><div className="button-ui text-h2 bold fcap">{row.brandname}</div></td>
                                                    <td width={60}><div className="button-ui bold">#{index + 1}</div></td>

 
                                                </tr>
                                            </table>
                                        </div>
                                        <div style={{ position: "relative" }}>
                                            <div className="w-back-30" style={{ zIndex: "2", position: "absolute", left: "0px", right: "0px", bottom: "0px" }}>
                                                <table>
                                                    <tr>
                                                        <td><div className="text-shadow-w text-h2 fcap bold">{row?.modelname}</div></td>
                                                        <td width={90} > <Rating productId={row.uid} /></td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <img src={row.thumbnail} onClick={() => navigate("/" + row.slug)} className="ads-items-default" />
                                        </div>

                                        <div className="p-1"  >
                                            <div className="text-h3 fcap m-b">{row.title.substring(0, 215)}</div>

                                            {row.child?.dealname != null && (
                                                <div>
                                                    <a className="red text-h3 items-back   rounded-sm">Deal: {row.child?.dealname}</a>
                                                </div>
                                            )}
                                            {Array.isArray(row.child) &&
                                                row.child.some(field => (field.category || "").toLowerCase() === "price") ? (
                                                row.child
                                                    .filter(
                                                        field =>
                                                            (field.category || "").toLowerCase() === "price" &&
                                                            field.fieldName !== "dealname"
                                                    )
                                                    .map((field, fIndex) => (
                                                        <div className="b-top" key={fIndex}>
                                                            <table>
                                                                <tbody>
                                                                    <tr>
                                                                        <td >
                                                                            <div className="text-h3 fcap p-11">
                                                                                {field.fieldName?.replaceAll("_", " ")}
                                                                            </div>
                                                                        </td>
                                                                        <td width={125}>
                                                                            <div className="flex">
                                                                                {field.fieldName === "discount" ? (
                                                                                    <>

                                                                                        <div className="text-h1 bold red">{field.fieldValue || ""}</div>
                                                                                        <span className="text-off text-h2">%</span>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span className="text-off text-h2">₹ </span>
                                                                                        <div className="text-h1 bold">{field.fieldValue || ""}</div>
                                                                                        <span className="text-off text-h2">.00</span>
                                                                                    </>
                                                                                )}
                                                                            </div>

                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ))
                                            ) : (
                                                <div className="p-2 text-h3 text-off">No price available</div>
                                            )}
                                            <div className="m-top-5 ">
                                                <table className="table-fixed">
                                                                <tr>
                                                        <td width={22}>{<Saved product={row.uid} />}</td>
                                                                
                                                                  <td width={40} >
                                                                    <div title="Compare" className="button-ui3 cursor "
                                                                      onClick={() => navigate("/compare/?slug=" + row.slug + "&uid=" + row.uid + "&cat=" + row.category + "&scat=" + row.subcategory)}
                                                                    ><IoIosGitCompare className="icon" /> {row.compare} </div>
                                                                  </td>
                                                      
                                                                    <td width={30}  >
                                                                    <Add_cart product={row.uid} />
                                                                  </td>
                                                                </tr>
                                                              </table>
                                            </div>
                                            <table className="table-fixed ">

                                                <tr>
                                                    <td><div onClick={() => navigate("/" + row.slug)} className="button-ui p-2 fill cursor"><MdShoppingCart className="icon" /> Buy Now</div></td>
                                                </tr>
                                            </table>



                                        </div>
                                        <CompareTechnicalDetails isLoading3={isLoading} technicaldata={compareData} />

                                    </div>
                                ))
                            )}
                        </div>

                    </div>


                </div>

            </div>
        </div>
    );
}
